export const SET_FAQSO = 'SET_FAQSO';
export const SET_FAQSN = 'SET_FAQSN';
export const SET_INFO = 'SET_INFO';
